export default __webpack_public_path__ + "static/media/abs.90c4f9cd.jpg";